import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AnnotationsEffects } from './effects/annotations.effects';
import * as fromAnnotations from './reducers/annotations.reducer';
import { AnnotationsService } from './services/annotations.service';
import { AnnotationsStoreFacade } from './facades/annotations-store.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromAnnotations.annotationsFeatureKey,
      fromAnnotations.reducer
    ),
    EffectsModule.forFeature([AnnotationsEffects]),
  ],
  providers: [AnnotationsService, AnnotationsStoreFacade],
})
export class AnnotationsStoreModule {}
